import { useRef, useEffect } from 'react';

export const useOutsideClick = (callback: () => void) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const { target } = event;
      if (
        ref.current &&
        target instanceof Node &&
        !ref.current.contains(target)
      ) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClick, true);

    return () => {
      document.removeEventListener('mousedown', handleClick, true);
    };
  }, [ref, callback]);

  return ref;
};
